export function CtrlTicker() {
  const items = [
    { label: "SYS", value: "ONLINE" },
    { label: "BUILD", value: "#4.09.26" },
    { label: "REGIÃO", value: "BR-SE-1" },
    { label: "UPTIME", value: "99.9%" },
    { label: "STATUS", value: "ONLINE" },
    { label: "LATÊNCIA", value: "—" },
    { label: "CPU", value: "—" },
    { label: "MEM", value: "—" },
    { label: "NET ↑", value: "—" },
    { label: "BUILD", value: "#4.09.26" },
    { label: "REGIÃO", value: "BR-SE-1" },
  ]

  // duplicate for seamless loop
  const all = [...items, ...items]

  return (
    <div className="ctrl-ticker">
      <div className="ctrl-ticker__label">SYS</div>
      <div className="ctrl-ticker__track">
        <div className="ctrl-ticker__inner">
          {all.map((item, i) => (
            <span key={i} className="ctrl-ticker__item">
              {item.label} <span>{item.value}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
